/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { bool, object } from 'prop-types';

import WithImageDesign from './WithImageDesign';
import WithRightIcon from './WithRightIcon';
import OfferGatewayDesign from './OfferGatewayDesign';
import TalonOneBanner from './TalonOneBanner';

const OfferDesignContainer = ({
    offer, notFirst,
}) => {
    const renderOfferByType = () => {
        const isOfferGateway = offer?.type === 'offer-gateway';
        const designType = isOfferGateway ? offer?.type : offer?.design_type;

        switch (designType) {
            case 'with-image':
                return <WithImageDesign offer={offer} notFirst={notFirst} />;
            case 'with-right-icon':
                return <WithRightIcon offer={offer} notFirst={notFirst} />;

            case 'offer-gateway':
                return <OfferGatewayDesign offer={offer} notFirst={notFirst} />;

            case 'talon-one':
                return <TalonOneBanner offer={offer} notFirst={notFirst} />;

            default:
                return null;
        }
    };

    return (
        <>
            {renderOfferByType()}
        </>
    );
};

OfferDesignContainer.propTypes = {
    offer: object,
    notFirst: bool,
};

OfferDesignContainer.defaultProps = {
    offer: {},
    notFirst: false,
};

export default OfferDesignContainer;
